<template>
  <master-main
    ref="masterMain"
    :addProperties="{ eventType: 1, routeToCreate: getModuleRoute }"
    :exportProperties="{
      pdf: {
        filename: `${$t('production.crews')}_${dateToday}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('production.crews')}_${dateToday}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('labor.workers'),
        data: 'workers',
        property: 'name',
        minWidth: 250,
      },
      {
        columnLabel: $t('common_words.company'),
        data: 'businesses',
        property: 'name',
        minWidth: 200,
      },
      {
        columnLabel: $t('common_words.farm'),
        data: 'farms',
        property: 'name',
        minWidth: 160,
      },
    ]"
    :route="getModuleRoute"
    :tableProperties="tableProperties"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
  />
</template>

<script>
import { getDateToday } from 'src/util/Util';
import CrewTable from './crew-table';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinRerender from 'src/mixins/mixin-rerender';

export default {
  name: 'Crews',
  components: { MasterMain },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinForm,
    MixinMain,
    MixinPermissions,
    MixinMenu,
    MixinRerender,
  ],
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '60%' },
    };
  },
  computed: {
    getModuleRoute() {
      return 'scales/crews';
    },
    dateToday() {
      return getDateToday();
    },
    buildTableProperties() {
      return {
        tableColumns: [...CrewTable().tableColumns],
        model: 'crews',
        effectTags: 'dark',
        defaultSort: { prop: 'name', order: 'ascending' },
      };
    },
  },
  mounted() {
    this.selectedItemOnMenu('scales');
  },
  beforeDestroy() {
    this.deselectedItemOnMenu('scales');
  },
};
</script>
